import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Layout } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined, SettingOutlined } from '@ant-design/icons';
import Logo from './Logo';
import NavProfile from './NavProfile';
import { toggleCollapsedNav, onMobileNavToggle } from 'redux/actions/Theme';
import { NAV_TYPE_TOP, SIDE_NAV_COLLAPSED_WIDTH, SIDE_NAV_WIDTH } from 'constants/ThemeConstant';
import utils from 'utils'
import NavNotification from "./NavNotification";
import './HeaderNav.css'
import NavSearchUsers from "./NavSearchUsers";
import Utils from "utils";
import LogoLevrangi from "./LogoLevrangi";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const { Header } = Layout;

export const HeaderNav = props => {
  const { navCollapsed, mobileNav, navType, headerNavColor, toggleCollapsedNav, onMobileNavToggle, isMobile, currentTheme, notifications } = props;

  const onSearchClose = () => {
  }

  const onToggle = () => {
    if(!isMobile) {
      toggleCollapsedNav(!navCollapsed)
    } else {
      onMobileNavToggle(!mobileNav)
    }
  }

  const [firstTime, setFirstTime] = useState(true)
  let history = useHistory();

  useEffect(() => {
    if(firstTime)
    {
      setFirstTime(false)
      if(Utils.CurrentUserApplication() === "LEVRANGI")
      {
        toggleCollapsedNav(true)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstTime])

  const isNavTop = navType === NAV_TYPE_TOP ? true : false
  const mode = ()=> {
    if(!headerNavColor) {
      return utils.getColorContrast(currentTheme === 'dark' ? '#00000' : '#ffffff' )
    }
    return utils.getColorContrast(headerNavColor)
  }
  const navMode = mode()
  const getNavWidth = () => {
    if(isNavTop || isMobile) {
      return '0px'
    }
    if(navCollapsed) {
      return `${SIDE_NAV_COLLAPSED_WIDTH}px`
    } else {
      return `${SIDE_NAV_WIDTH}px`
    }
  }

  

  useEffect(() => {
    if(!isMobile) {
      onSearchClose()
    }
  })

  return (
    <Header className={`app-header ${navMode}`} style={{backgroundColor: headerNavColor}}>
      <div className={`app-header-wrapper ${isNavTop ? 'layout-top-nav' : ''}`}>
        {Utils.CurrentUserApplication() === "SAMAC" ? <Logo logoType={navMode}/> : <LogoLevrangi logoType={navMode}/>}
        <div className="nav" style={{width: `calc(100% - ${getNavWidth()})`}}>
          <div className="nav-left">
            <ul className="ant-menu ant-menu-root ant-menu-horizontal">          
              {
                isNavTop && !isMobile ?
                null
                :
                <li className="ant-menu-item ant-menu-item-only-child" onClick={() => {onToggle()}}>
                  {navCollapsed || isMobile ? <MenuUnfoldOutlined className="nav-icon" /> : <MenuFoldOutlined className="nav-icon" />}
                </li>
              }
            </ul>
          </div>

          <div className="nav-right">

            {!Utils.CurrentUserEndorsable() && Utils.CurrentUserApplication() === "SAMAC" && <NavSearchUsers notifications={notifications} />}
            {Utils.CurrentUserApplication() === "SAMAC" && <NavNotification notifications={notifications} />}
            {Utils.CurrentUserApplication() === "SAMAC" && (Utils.GetCurrentUserRole() === "SA" || Utils.canShowNav("utilities") || Utils.GetCurrentUser() === "IMP000028") &&
              <span className="navSetting" onClick={() => {history.push("/utilities")}}>
              <SettingOutlined fill={"#455560"} style={{fontSize:"20px", marginTop: "1.5rem", padding: "0 1rem"}}></SettingOutlined>
              </span>}

            <NavProfile />
          </div>
        </div>
      </div>
    </Header>
  )
}

const mapStateToProps = ({ theme, session }) => {
  const { navCollapsed, navType, headerNavColor, mobileNav, currentTheme, direction } =  theme;
  const { notifications } = session;
  return { navCollapsed, navType, headerNavColor, mobileNav, currentTheme, direction, notifications }
};

export default connect(mapStateToProps, {toggleCollapsedNav, onMobileNavToggle})(HeaderNav);